import styled from "styled-components";
import { Modal } from "components/Modal";

export const KeyStatsModalContainer = styled(Modal)`
  .modal-dialog {
    min-width: 920px;

    .modal-content {
      padding: 0px;
      border: 0px;
    }

    .modal-body {
      padding: 0;
      margin-top: 0px;

      .heading {
        display: flex;
        align-items: center;
        padding: 14px 15px;
        background-color: ${({ theme }) => theme.modal.bg.secondary};
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        .back-btn {
          cursor: pointer;
        }

        h2 {
          width: 100%;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }

      .modal-ul {
        padding: 20px;
      }

      .btn-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 30px;

        button {
          padding: 10px 74px;
        }
      }
    }
  }

  @media screen and (max-width: 980px) {
    .modal-dialog {
      min-width: auto;
    }
  }
`;
